import { AccountType } from "@ctypes";
import { i18n, Translations } from "@i18n";

export const content: Record<AccountType, string> = {
  [AccountType.Corporate]: i18n.t(Translations.AccountBalanceTypeCorporate),
  [AccountType.FiveTwoNinePlan]: i18n.t(Translations.AccountBalanceTypeFiveTwoNinePlan),
  [AccountType.GeneralInvesting]: i18n.t(Translations.AccountBalanceTypeGeneralInvesting),
  [AccountType.Individual]: i18n.t(Translations.AccountBalanceTypeIndividual),
  [AccountType.Individual_529]: i18n.t(Translations.AccountBalanceTypeFiveTwoNinePlan),
  [AccountType.IraRoth]: i18n.t(Translations.AccountBalanceTypeRothIra),
  [AccountType.IraSep]: i18n.t(Translations.AccountBalanceTypeIraSep),
  [AccountType.IraTraditional]: i18n.t(Translations.AccountBalanceTypeTraditionalIra),
  [AccountType.Joint]: i18n.t(Translations.AccountBalanceTypeJoint),
  [AccountType.JuniorIraRoth]: i18n.t(Translations.AccountBalanceTypeJuniorRothIra),
  [AccountType.JuniorRothIra]: i18n.t(Translations.AccountBalanceTypeJuniorRothIra),
  [AccountType.RothIra]: i18n.t(Translations.AccountBalanceTypeRothIra),
  [AccountType.TraditionalIra]: i18n.t(Translations.AccountBalanceTypeTraditionalIra),
  [AccountType.Cash]: i18n.t(Translations.AccountBalanceTypeCash),
  [AccountType.CustodialRothIra]: i18n.t(Translations.AccountBalanceTypeCustodialRothIra),
  [AccountType.HarvestUtmaUgma]: i18n.t(Translations.AccountBalanceTypeHarvestUtmaUgma),
  [AccountType.Reserve]: i18n.t(Translations.AccountBalanceTypeReserve),
};
